<template>
    <div>
        <div class="columns">
            <div class="column">
                <form @submit.prevent="submit()">
                    <b-field label="ລະຫັດໝວດ">
                        <b-input v-model="category.code"
                                 placeholder="ປ້ອນລະຫັດໝວດສິນຄ້າ"
                                 required
                                 validation-message="ຕ້ອງປ້ອນລະຫັດໝວດສິນຄ້າ"></b-input>
                    </b-field>
                    <b-field label="ຊື່ໝວດ">
                        <b-input v-model="category.name"
                                 placeholder="ປ້ອນຊື່ໝວດສິນຄ້າ"
                                 required
                                 validation-message="ຕ້ອງປ້ອນຊື່ໝວດສິນຄ້າ"></b-input>
                    </b-field>
                    <div class="columns">
                        <div class="column">
                            <b-button type="is-primary"
                                      class="button"
                                      icon-left="content-save-edit-outline"
                                      expanded
                                      native-type="submit">ບັນທືກ
                            </b-button>
                        </div>
                        <div v-if="isEditing" class="column">
                            <b-button type="is-danger"
                                      icon-left="close-circle"
                                      expanded
                                      @click="resetForm">ຍົກເລີກ
                            </b-button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="my-content is-two-thirds column">
                <div class="columns">
                    <div class="column">
                        <h1 class="title is-5">ລາຍການໝວດສິນຄ້າ</h1>
                    </div>
                    <div class="column has-text-right">
                        <b-button v-if="selectedCategory" class="is-small"
                                  type="is-warning"
                                  icon-left="cancel"
                                  @click="resetForm">ລ້າງລາຍການທີ່ເລືອກ
                        </b-button>
                        <b-button class="ml-2 is-small"
                                  type="is-success"
                                  icon-left="pencil-outline"
                                  :disabled="!selectedCategory"
                                  @click="crud('EDIT')">ແກ້ໄຂ
                        </b-button>
                        <b-button class="ml-2 is-small"
                                  type="is-danger"
                                  icon-left="trash-can-outline"
                                  :disabled="!selectedCategory"
                                  @click="crud('REMOVE')">ລຶບ
                        </b-button>
                    </div>
                </div>
                <table-skeleton v-if="categories.length === 0"/>
                <b-field v-if="categories.length > 0">
                    <b-input placeholder="ຄົ້ນຫາ" v-model="search"/>
                </b-field>
                <b-table v-if="categories.length > 0" :data="filter"
                         class="database-table"
                         striped
                         paginated
                         per-page="20"
                         :current-page.sync="currentPage"
                         :selected.sync="selectedCategory"
                         :default-sort-direction="defaultSortDirection"
                         :sort-icon="sortIcon"
                         :sort-icon-size="sortIconSize"
                         :loading="isLoading"
                         default-sort="created"
                         ref="databasetable">
                    <b-table-column label="ລະຫັດໝວດ" sortable field="code" v-slot="props">
                        <p>{{ props.row.code }}</p>
                    </b-table-column>
                    <b-table-column label="ຊື່ໝວດ" sortable field="name" v-slot="props">
                        <p>{{ props.row.name }}</p>
                    </b-table-column>
                    <b-table-column label="ວັນທີສ້າງ" sortable field="created" v-slot="props">
                        <p>{{ props.row.created | formatEuDate }}</p>
                    </b-table-column>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
    import {categoriesCollection} from '../firebase';
    import TableSkeleton from "../components/TableSkeleton";

    export default {
        name: "Category",
        components: {TableSkeleton},
        data() {
            return {
                currentPage: 1,
                defaultSortDirection: 'asc',
                sortIcon: 'arrow-up',
                sortIconSize: 'is-small',
                isLoading: false,
                isEditing: false,
                search: '',
                categories: [],
                category: {
                    code: null,
                    name: null
                },
                selectedCategory: null,
                isExisted: false
            }
        },
        firestore() {
            return {
                categories: categoriesCollection.where('deleted', '==', false).orderBy('created', 'desc')
            }
        },
        computed: {
            filter: function () {
                const search = new RegExp(this.search, 'i')
                let data = []
                for (let i in this.categories) {
                    if (this.categories[i].name.match(search) || this.categories[i].code.match(search)) {
                        data.push(this.categories[i])
                    }
                }
                return data
            }
        },
        methods: {
            getCategoryById: async function (code) {
                const snapshot = categoriesCollection.where('code', '==', code).get();
                const categoryQuerySnapshot = await Promise.resolve(snapshot);
                return categoryQuerySnapshot.docs
            },
            crud: function (action) {
                if (action === 'EDIT') {
                    this.isEditing = true;
                    this.category.code = this.selectedCategory.code;
                    this.category.name = this.selectedCategory.name;
                }
                if (action === 'REMOVE') {
                    this.$swal({
                        text: "ຕ້ອງການລຶບໝວດ " + this.selectedCategory.name + " ແທ້ບໍ່?!",
                        icon: 'warning',
                        showCancelButton: true,
                    }).then((result) => {
                        if (result.value) {
                            this.isLoading = true;
                            categoriesCollection.doc(this.selectedCategory.id).update({deleted: true})
                                .then(docRef => {
                                    console.log(docRef);
                                    this.resetForm();
                                })
                                .catch(err => {
                                    console.log(err);
                                })
                        }
                    })
                }
            },
            submit: async function () {
                this.isLoading = true;

                if (this.selectedCategory) {
                    await this.update();
                    return
                }

                await this.getCategoryById(this.category.code).then(res => {
                    this.isExisted = false
                    res.forEach(docSnapshot => {
                        const existedItem = docSnapshot.data();
                        if (existedItem) {
                            this.$swal('', 'ມີລະຫັດໝວດ ' + this.category.code + ' ແລ້ວ!!', 'error');
                            this.isLoading = false;
                            this.isExisted = true
                        }
                    })
                })

                if (!this.isExisted) {
                    const req = {
                        ...this.category,
                        created: this.getCurrentDateTime(),
                        deleted: false
                    };
                    categoriesCollection.add(req)
                        .then(docRef => {
                            console.log(docRef.id);
                            this.$buefy.snackbar.open(`ການດໍາເນີນການສໍາເລັດ`)
                            this.resetForm();
                        })
                        .catch(err => {
                            console.log(err);
                            this.$swal('', err, 'error')
                        })
                }
            },
            update: async function () {
                await this.getCategoryById(this.category.code).then(res => {
                    this.isExisted = false
                    res.forEach(docSnapshot => {
                        const existedItem = docSnapshot.data();
                        if (existedItem && existedItem.code !== this.selectedCategory.code) {
                            this.$swal('', 'ມີລະຫັດໝວດ ' + this.category.code + ' ແລ້ວ!!', 'error');
                            this.isLoading = false;
                            this.isExisted = true
                        }
                    })
                })

                if (!this.isExisted) {
                    const req = {
                        ...this.category,
                    };
                    categoriesCollection.doc(this.selectedCategory.id).update(req)
                        .then(docRef => {
                            console.log(docRef);
                            this.$buefy.snackbar.open(`ການດໍາເນີນການສໍາເລັດ`)
                            this.resetForm();
                        })
                        .catch(err => {
                            console.log(err);
                            this.$swal('', err, 'error')
                        })
                }
            },
            resetForm() {
                this.isLoading = false;
                this.isEditing = false;
                this.category.code = null;
                this.category.name = null;
                this.selectedCategory = null;
            }
        },
        watch: {
            selectedCategory() {
                if (this.selectedCategory && this.isEditing) {
                    this.category.code = this.selectedCategory.code;
                    this.category.name = this.selectedCategory.name;
                }
            }
        }
    }
</script>

<style scoped>

</style>